import * as React from 'react';
import { Link } from 'react-router-dom';

import Icon from '../Icon/Icon';

interface Props {
  link?: any;
  title?: string;
  subtitle?: string;
  icon?: string;
  children?: any;
  handleClick?: any;
}

export default class ActionCard extends React.Component<Props> {
  static defaultProps = {
    link: false,
  };

  render() {
    const content = (
      <>
        <div className="media-left">
          <Icon icon={this.props.icon} />
        </div>
        <div className="media-content">
          <strong>{this.props.title}</strong>
          <br />
          <div className="has-text-grey">{this.props.subtitle}</div>
          {this.props.children}
        </div>
      </>
    );

    if (this.props.handleClick) {
      return (
        <a className="media" onClick={this.props.handleClick}>
          {content}
        </a>
      );
    }
    if (this.props.link) {
      return (
        <Link className="media" to={this.props.link}>
          {content}
        </Link>
      );
    }
    return <div className="media">{content}</div>;
  }
}
